import React, { useContext, useEffect } from 'react';
import { AudioContext } from '../../libs/audio-provider';
import { BackgroundContext } from '../../libs/BackgroundProvider';
import { useGameContext } from "../../libs/GameProvider";
import SvgButton from '../ui/SvgButton';

function GamePrintingCover() {
  const { playClick } = useContext(AudioContext);
  const { setBg } = useContext(BackgroundContext);
  const { gameDifficulty, dispatch } = useGameContext();

  useEffect(() => {
    setBg('game-printing/game3-cover-background', 'game-printing/game3-cover-background/images');
  }, [setBg]);

  return (
    <div className="fullscreen">
      <div className="container">
        {/* <button className="difficulty-button" style={{ right: 20, top: 20, width: 78, height: 78 }} onClick={() => { playClick(); dispatch(`difficulty-${3 === gameDifficulty.difficulty ? 1 : 3}`) }}>
          {
            3 === gameDifficulty.difficulty
              ? <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/1-game-cover/cover-button9`} src1="-select.svg" src2=".svg" alt="進階"></SvgButton>
              : <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/1-game-cover/cover-button9`} src1=".svg" src2="-select.svg" alt="進階"></SvgButton>
          }
        </button> */}
        <button className="start-button" style={{}} onClick={() => { playClick(); dispatch({ type: 'game-printing', state: 'description' }) }}>
          <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/game-printing/game3-start-button`} src1=".svg" src2="select.svg" alt="遊戲開始"></SvgButton>
        </button>
      </div>
    </div>
  )
}

export default GamePrintingCover;
